import { render, staticRenderFns } from "./RegulationsOverviewView.vue?vue&type=template&id=57a0c8bf&"
import script from "./RegulationsOverviewView.vue?vue&type=script&lang=ts&"
export * from "./RegulationsOverviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports